import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
import { ToolkitService } from '../../services/toolKit/toolkit.service';
import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ConfigurationControlService } from '../../services/configuration/configurationControl.service';


declare var $: any;
@Component({
  selector: 'app-tool-kit',
  templateUrl: './tool-kit.component.html',
  styleUrls: ['./tool-kit.component.css']
})
export class ToolKitComponent implements OnInit {
  @HostListener('window:mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (this.isParentById(this.COMPONENT_ID, target, 0)) {
      this._toolkitService.eventHighlightText()
    }
  }

  private COMPONENT_ID = "editor"

  constructor(private elRef: ElementRef,
    private _toolkitService: ToolkitService,
    private _configurationControlService: ConfigurationControlService,
    private sanitizer: DomSanitizer) {
    pdfDefaultOptions.assetsFolder = 'assets';
  }

  private isOpen = false;
  private urlOpen = "";

  urlhtmlSafe: SafeResourceUrl;

  public closeModel() {
    this.isOpen = false;
    $("#modalzoom").removeClass("isOpenZoom");
  }

  public noUse(event: any) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }

  private isParentById(idPadre: string, element: HTMLElement, iteration: number): boolean {
    if (element.id === idPadre) {
      return true;
    }
    if (iteration > 20)
      return true

    if (element.parentElement) {
      return this.isParentById(idPadre, element.parentElement, iteration + 1);
    }
    return false;
  }

  ngOnInit() {
    this._toolkitService.changeZoom.subscribe(isOpen => {
      return this.isOpen = isOpen;
    });

    this._toolkitService.urlZoom.subscribe(url => {
      this.urlOpen = url;
    });

    //Url de la pagina para mostrar en componente HTML
    const urlFrame = this._configurationControlService.examConfiguration.html;
    if (urlFrame) {
      this.urlhtmlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(urlFrame);
    }

  }

  public closeQuickNotes() {
    this._toolkitService.activateQuickNotes = false;
    $("#modalQuickNotes").hide();
  }

  public closeCalculator() {
    $("#modalCalculator").hide();
    this._toolkitService.activateCalculator = false;
  }

  public closeShowPdf() {
    $("#modalShowPdf").hide();
    this._toolkitService.activateShowPdf = false;
  }

  public closeShowHtml() {
    $("#modalShowHtml").hide();
    this._toolkitService.activateShowHtml = false;
  }

  clearNotes(): void {
    if (confirm('¿Estás seguro de que deseas eliminar todas las notas?')) {
      this._toolkitService.clearQuickNotes();
    }
  }

}
